export default Object.freeze({
    SI: 'SI',
    NO: 'NO'
})
